<template>
  <div class="checkout-header-step">
    <div class="checkout-header-step-inner">
      <span v-if="label" class="label">{{ label }}</span>
      <p v-if="label && hasAppliedCoupon" class="pipe">&#124;</p>
      <CouponBadge v-if="hasAppliedCoupon" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useScreenStore } from '@/store/ScreenStore'
import { useCouponStore } from '@/store/CouponStore'
import CouponBadge from '@/components/shared/CouponBadge.vue'

const screenStore = useScreenStore()
const couponStore = useCouponStore()

const { hasAppliedCoupon } = storeToRefs(couponStore)
const { currentScreenName } = storeToRefs(screenStore)

const label = computed(() => currentScreenName.value)
</script>
<style lang="scss" scoped>
.checkout-header-step {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 $spacer-2;

  &-inner {
    display: flex;
    white-space: nowrap;
  }

  .label {
    display: none;

    @include media-breakpoint(md) {
      display: block;
    }
  }

  .pipe {
    font-size: 20px;
    margin: 0 16px;
    display: none;

    @include media-breakpoint(md) {
      display: block;
    }
  }
}
</style>
